import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main">
        <div className="footer-logo-section">
          <img src={logo} alt="Tech Market B.A Logo" className="footer-logo" />
        </div>
        <div className="footer-links-section">
          <div className="footer-column">
            <h4>Acerca de Tech Market</h4>
            <Link to="/about-us">Acerca de nosotros</Link>
            <Link to="/affiliates">Afiliados</Link>
            <Link to="/our-networks">Nuestras redes</Link>
          </div>
          <div className="footer-column">
            <h4>Compras y Ventas</h4>
            <Link to="/sell-components">Vendé tus componentes</Link>
            <Link to="/returns-policy">Política de retorno</Link>
            <Link to="/vendor-info">Información de vendedor</Link>
            <Link to="/shipping">Envíos como vendedor</Link>
          </div>
          <div className="footer-column">
            <h4>Ayuda</h4>
            <Link to="/help-center">Centro de Ayuda</Link>
            <Link to="/vendor-services">Servicios al cliente</Link>
            <Link to="/contact">Mail: help@techmarketba.com</Link>
          </div>
          <div className="footer-column">
            <h4>Acerca de nosotros</h4>
            <Link to="/affiliates">Afiliados</Link>
            <Link to="/our-networks">Nuestras redes</Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-legal-links">
          <Link to="/terms">Términos y condiciones</Link>
          <Link to="/privacy-policy">Política de Privacidad</Link>
          <Link to="/cookie-preferences">Preferencia de Cookies</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} Tech Market B.A. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;